
<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>下载记录列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick()">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>下载记录列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width:100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="nickName" label="姓名"></el-table-column>
          <el-table-column prop="targetTitle" label="标题"></el-table-column>
          <el-table-column prop="targetName" label="分类"></el-table-column>
          <el-table-column prop="deviceName" label="终端类型"></el-table-column>
          <el-table-column prop="createTime" label="下载时间"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-chang="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-size="currentPage4"
            :page-sizes="[10,20,30,50,100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      query: {},
      form: {},
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage4: 1
    };
  },
  methods: {
    handleSizeChange: function(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange: function(val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    // 排序
    sortChange: function(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageIndex = _this.currentPage4;
      params.pageSize = _this.pageSize;
      var link = url.getBaseData("getlist_record");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selClick: function() {
      this.currentPage4 = 1;
      this.getList();
    }
  },
  mounted() {
    //   列表
    this.getList();
  }
};
</script>